import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from "@ngx-translate/core";
import { LaddaModule } from 'angular2-ladda';

import { NumbersRoutingModule } from './numbers-routing.module';
import { SharedModule } from 'src/app/shared/shared.module';
import {
  NumbersMainComponent
} from './containers';

import {
  NumbersTableComponent,
  NumberInfoPopupComponent
} from './components';
import { CompaniesModule } from '../companies/companies.module';

@NgModule({
    declarations: [
        NumbersMainComponent,
        NumbersTableComponent,
        NumberInfoPopupComponent
    ],
    imports: [
        NgbModule,
        NumbersRoutingModule,
        CommonModule,
        ReactiveFormsModule,
        CompaniesModule,
        FormsModule,
        NgxSkeletonLoaderModule,
        TranslateModule.forChild(),
        LaddaModule.forRoot({
            spinnerColor: 'grey',
            style: 'zoom-in'
        }),
        SharedModule
    ],
    providers: [
        DatePipe
    ]
})
export class NumbersModule { }
